import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const EcommerceDashboard = lazy(() => import('./pages/EcommerceDashboard'));
const OrderList = lazy(() => import('./pages/OrderList'));
const OrderView = lazy(() => import('./pages/OrderView'));
const BillList = lazy(() => import('./pages/BillList'));
const BillCreate = lazy(() => import('./pages/BillCreate'));
const BillView = lazy(() => import('./pages/BillView'));
const CustomerList = lazy(() => import('./pages/CustomerList'));
const CustomerView = lazy(() => import('./pages/CustomerView'));
const EcommerceReports = lazy(() => import('./pages/EcommerceReports'));
const PaymentDiscounts = lazy(() => import('./pages/PaymentDiscounts'));
const ClickCollectList = lazy(() => import('./pages/ClickCollectList'));
const ClickCollectReport = lazy(() => import('./pages/ClickCollectReport'));
const ClickCollectView = lazy(() => import('./pages/ClickCollectView'));
const CmsBanners = lazy(() => import('./pages/CmsBanners'));
const CmsBannerGroup = lazy(() => import('./pages/CmsBannerGroup'));

const ecommerceRoutes: RouteObject[] = [
    { index: true, element: <EcommerceDashboard /> },
    { path: 'orders', element: <OrderList /> },
    { path: 'orders/:id', element: <OrderView /> },
    { path: 'payment-discounts', element: <PaymentDiscounts /> },
    { path: 'click-collect', element: <ClickCollectList /> },
    { path: 'click-collect/report', element: <ClickCollectReport /> },
    { path: 'click-collect/:id', element: <ClickCollectView /> },
    { path: 'bills', element: <BillList /> },
    { path: 'bills/create', element: <BillCreate /> },
    { path: 'bills/:uuid', element: <BillView /> },
    { path: 'customers', element: <CustomerList /> },
    { path: 'customers/:id', element: <CustomerView /> },
    { path: 'reports', element: <EcommerceReports /> },
    { path: 'cms', element: <Navigate to="/ecommerce/cms/banners" replace /> },
    { path: 'cms/banners', element: <CmsBanners /> },
    { path: 'cms/banners/:id', element: <CmsBannerGroup /> },
];

export default ecommerceRoutes;
